// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1daZK","actions":"GroupTable_actions__2Upln","deleteModalFooter":"GroupTable_deleteModalFooter__1-gfW"};